// Astrea Ops - Database "Look up online" (v7.85, 18 Oct 2026).
//
// Asks /api/ai-entity-lookup to find a vendor's, venue's or client's official details on the
// web. Nothing is saved here: the app shows what came back next to what the record already has
// and the person ticks what to keep (EntityLookupHost in src/App.jsx).
import { authHeaders } from './apiAuth';

export async function lookupEntity({ type, name, hint = '', current = {} }, { signal } = {}) {
  const r = await fetch('/api/ai-entity-lookup', {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ type, name, hint, current }),
    signal,
  });
  let data = {};
  try { data = await r.json(); } catch (e) { data = {}; }
  if (!r.ok) throw new Error(data.error || ('The online lookup failed (HTTP ' + r.status + ').'));
  return {
    found: !!data.found,
    matchNote: data.matchNote || '',
    fields: data.fields && typeof data.fields === 'object' ? data.fields : {},
    sourcesUsed: Array.isArray(data.sourcesUsed) ? data.sourcesUsed : [],
  };
}
